import React, { FunctionComponent, ReactNode } from 'react';
import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';
import FormattedMoney, {
  FormattedMoneyProps,
} from '@app/shop/components/FormattedMoney';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  width: 100%;
  text-align: right;

  &:not(:last-of-type) {
    margin-bottom: ${theme.space[3]};
  }
`;

export const Total: FunctionComponent<{
  label: ReactNode;
  amount: FormattedMoneyProps;
  // Needed to extend via @emotion/styled
  className?: string;
}> = ({ label, amount, className, ...props }) => (
  <Grid {...props}>
    <dt className={className}>{label}</dt>
    <dd className={className}>
      <FormattedMoney {...amount} />
    </dd>
  </Grid>
);

export const GrandTotal = styled(Total)`
  font-family: ${theme.fonts.fontBold};
  font-size: ${rem(20)};
`;

export const TaxInfo = styled.p`
  color: ${theme.colors.info};
  font-size: ${rem(15)};
  margin: ${rem(24)} 0 0 0;
`;
